export function reverseData(newObj, oriObj, rules) {
    rules.forEach(v => {
      if (oriObj[v.value]) {
        newObj[v.key] = oriObj[v.value]
      }
    })
    return newObj
  }